export function fetchAllInteractionDrafts(interaction_id) {
  return Promise.resolve({
    data: [
      {
        _id: "string",
        timestamp: "2024-09-16T07:56:48.479Z",
        interaction_id: "f36f80c8-3408-4249-a581-59d1706a6589",
        user_id: "45689756",
        user_full_name: "Nikita GUI",
        organization_id: "f36f80c8",
        draft_text:
          "Hello John, Thank you for bringing this to our attention. The finance refund policy has been updated recently. Now, refunds should be processed and returned to the customer within the same day of the request approval.",
      },
    ],
  });
  // const url = `/api/drafts/interaction/${interaction_id}`;
  // return fetchJSON(url, null, null, "get");
}

export function deleteDraft(id) {
  return Promise.resolve(true);
  // const url = `/api/comments/${id}`;
  // return fetchJSON(url, null, null, "delete");
}
